module.exports = __webpack_public_path__ + "icon-minimize-modal.png";